import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

/*
 * Dressed like the exclusion-reviewer notice (ReviewerInfoWrapper): the
 * quiet lavender info panel the reporter has already seen on this page,
 * not a standalone card competing with the page title.
 */
export const DisclosureWrapper = styled.section(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.background};
        border-radius: ${radius['8']}px;
        display: flex;
        flex-direction: column;
        margin-bottom: 24px;
        padding: 36px 32px 40px 32px;
        width: 100%;

        @media (max-width: ${breakpoints.md}px) {
            margin-bottom: 16px;
            padding: 24px 20px 28px 20px;
        }
    `,
);

/* The icon-plus-label row the OPTIONAL panel above uses, so the two panels
 * introduce themselves the same way. */
export const DisclosureHeader = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
`;

export const DisclosureTitle = styled(Typography.TextBody_12_20)`
    font-weight: 700;
    padding-left: 8px;
`;

export const DisclosureText = styled(Typography.TextBody_14_24)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.primary};
        margin-top: 4px;
    `,
);

export const DisclosureList = styled.ul(
    ({ theme: { palette } }) => css`
        color: ${palette.text.primary};
        font-size: 14px;
        line-height: 24px;
        margin: 4px 0 0;
        padding-left: 20px;
    `,
);

export const DisclosureListItem = styled.li`
    margin-top: 4px;
`;

export const PrivateNote = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        margin-top: 12px;
    `,
);
